// Components
import { MessageContainer, MessageImg, MessageText } from "./styles";
// Assets
import WarningImg from "../../assets/icons/ico_warning.svg";

const WarningMessage = ({ message, margin }) => {
  return (
    <MessageContainer margin={margin}>
      <MessageImg src={WarningImg} alt="ico-warning" />
      <MessageText>{message}</MessageText>
    </MessageContainer>
  );
};

export default WarningMessage;
